
export default function dadosTabelas() {
  /* nomeapi: => { opcional } NOME DA TABELA NA API (se for diferente do nome local),
  campoatt: => CAMPO DE DATA PARA UTILIZAR NA HORA DA ATUALIZACAO,
  prefixo: => PREFIXO DA TABELA LOCAL (usado para montar o idnuvem),
  model =>  FUNÇÃO QUE FORMATA O DADO QUE VEM DA API PARA O BANCO LOCAL,
  */
  return {
    parametro: {
      campoatt: 'pardataalteracao',
      prefixo: 'par',
      model: parametro
    },
    destinoitem: {
      campoatt: 'deidataalteracao',
      prefixo: 'dei',
      model: destinoitem
    },
    formapagto: {
      campoatt: 'fopdataalteracao',
      prefixo: 'fop',
      model: formapagto
    },
    tipopedidovenda: {
      campoatt: 'tpvdataalteracao',
      prefixo: 'tpv',
      model: tipopedidovenda
    },
    planopagamento: {
      campoatt: 'plpdataalteracao',
      prefixo: 'plp',
      model: planopagamento
    },
    vendedor: {
      campoatt: 'veddataalteracao',
      prefixo: 'ved',
      model: vendedor
    },
    cliente: {
      campoatt: 'clidataalteracao',
      prefixo: 'cli',
      model: cliente
    },
    pedido: {
      campoatt: 'peddataalteracao',
      prefixo: 'ped',
      model: pedido
    },
    pedidoitem: {
      campoatt: 'peidataalteracao',
      prefixo: 'pei',
      model: pedidoitem
    },
    produtosugerido: {
      campoatt: 'prsdataalteracao',
      prefixo: 'prs',
      model: produtosugerido
    },
    totalpedido: {
      campoatt: 'topdataalteracao',
      prefixo: 'top',
      model: totalpedido
    },
    visita: {
      campoatt: 'visdataalteracao',
      prefixo: 'vis',
      model: visita
    },
    financeiro: {
      campoatt: 'findataalteracao',
      prefixo: 'fin',
      model: financeiro
    },
    venda: {
      campoatt: 'vendataalteracao',
      prefixo: 'ven',
      model: venda
    },
    produto: {
      campoatt: 'prodataalteracao',
      prefixo: 'pro',
      model: produto
    }
  }
}

// --- MODELS DE FORMATAÇÃO (API -> DEXIE) ---

export function parametro(item) {
    return {
        paridnuvem: item.id,
        pardataalteracao: item.pardataalteracao,
        datainportacao: item.datainportacao,
        empresa: item.empresa,
        linkwebservice: item.linkwebservice,
        // databaixado: new Date() // Opcional, se quiser controlar quando baixou
    }
}

export function destinoitem(item) {
    return {
        deiidnuvem: item.id,
        deidataalteracao: item.deidataalteracao,
        iddestinoitem: item.iddestinoitem,
        descricao: item.descricao
    }
}

export function formapagto(item) {
    return {
        fopidnuvem: item.id,
        fopdataalteracao: item.fopdataalteracao,
        idformapagto: item.idformapagto,
        descricao: item.descricao
    }
}

export function tipopedidovenda(item) {
    return {
        tpvidnuvem: item.id,
        tpvdataalteracao: item.tpvdataalteracao,
        idtipopedidovenda: item.idtipopedidovenda,
        descricao: item.descricao,
        idplanopagto: item.idplanopagto,
        idformapagto: item.idformapagto,
        iddestinoitem: item.iddestinoitem
    }
}

export function planopagamento(item) {
    return {
        plpidnuvem: item.id,
        plpdataalteracao: item.plpdataalteracao,
        idplanopagto: item.idplanopagto,
        descricao: item.descricao,
        condicaovalorde: item.condicaovalorde,
        condicaovalorate: item.condicaovalorate,
        tipoplano: item.tipoplano
    }
}

export function vendedor(item) {
    return {
        vedidnuvem: item.id,
        veddataalteracao: item.veddataalteracao,
        idvendedor: item.idvendedor,
        codigo: item.codigo,
        nome: item.nome,
        senha: item.senha,
        ultimologado: item.ultimologado
    }
}

export function cliente(item) {
    return {
        cliidnuvem: item.id,
        clidataalteracao: item.clidataalteracao,
        idcliente: item.idcliente,
        nome: item.nome,
        nomefantasia: item.nomefantasia,
        cidade: item.cidade,
        cnpj_cpf: item.cnpj_cpf
    }
}

export function pedido(item) {
    return {
        pedidnuvem: item.id,
        peddataalteracao: item.peddataalteracao,
        idpedido: item.idpedido,
        idcliente: item.idcliente,
        data: item.data,
        numero: item.numero,
        idtipopedidovenda: item.idtipopedidovenda,
        atendido: item.atendido,
        idpedidoditemd: item.idpedidoditemd
    }
}

export function pedidoitem(item) {
    return {
        peiidnuvem: item.id,
        peidataalteracao: item.peidataalteracao,
        idpedidoitem: item.idpedidoitem,
        idcortamanhofinal: item.idcortamanhofinal,
        idpedido: item.idpedido,
        atendido: item.atendido,
        idpedidoditemd: item.idpedidoditemd
    }
}

export function produtosugerido(item) {
    return {
        prsidnuvem: item.id,
        prsdataalteracao: item.prsdataalteracao,
        idprodutosugerido: item.idprodutosugerido,
        idgrupo: item.idgrupo,
        descricao: item.descricao
    }
}

export function totalpedido(item) {
    return {
        topidnuvem: item.id,
        topdataalteracao: item.topdataalteracao,
        idtotalpedido: item.idtotalpedido,
        data: item.data,
        valor: item.valor
    }
}

export function visita(item) {
    return {
        visidnuvem: item.id,
        visdataalteracao: item.visdataalteracao,
        idvisita: item.idvisita,
        datavisita: item.datavisita,
        datadigitacao: item.datadigitacao,
        motivo: item.motivo,
        observacao: item.observacao,
        idcliente: item.idcliente,
        latitude: item.latitude,
        longitude: item.longitude,
        atendido: item.atendido
    }
}

export function financeiro(item) {
    return {
        finidnuvem: item.id,
        findataalteracao: item.findataalteracao,
        idfinanceiro: item.idfinanceiro,
        idcliente: item.idcliente,
        documento: item.documento,
        emissao: item.emissao,
        vencimento: item.vencimento,
        saldo: item.saldo,
        datafinal: item.datafinal
    }
}

export function venda(item) {
    return {
        venidnuvem: item.id,
        vendataalteracao: item.vendataalteracao,
        idvenda: item.idvenda,
        idcliente: item.idcliente,
        idcortamanhofinal: item.idcortamanhofinal,
        data: item.data,
        privenda: item.privenda,
        cidade: item.cidade,
        idvendedor: item.idvendedor,
        iditensvenda: item.iditensvenda
    }
}

export function produto(item) {
    return {
        proidnuvem: item.id,
        prodataalteracao: item.prodataalteracao,
        idcortamanhofinal: item.idcortamanhofinal,
        codigointerno: item.codigointerno,
        codigofuncao: item.codigofuncao,
        descricaogrupo: item.descricaogrupo,
        estoque: item.estoque,
        idgrupo: item.idgrupo,
        ctfqtdecomboleva: item.ctfqtdecomboleva,
        ctflimitepromocoesporvenda: item.ctflimitepromocoesporvenda
    }
}